export default __webpack_public_path__ + "static/media/notFound.23cc036d.png";